module.exports = __webpack_public_path__ + "img/logo.64a17b40.png";